/**
 * Sector Race — the 11 SPDR sector funds racing SPY (`docs/sector-race-widget-mock.html`).
 * A frame around `RaceView`, which ETF Performance's Race view draws too.
 */
import { WIDGET_META } from "../../lib/brief-board";
import { useIsNarrow } from "../../lib/use-narrow";
import { RaceControls, RaceSubtitle, RaceView, useRaceData, useRaceSettings } from "./RaceView";
import { DataState, WidgetCard, type WidgetProps } from "./WidgetCard";

/** Below this many grid columns the Δrank column and the header's middle label drop. */
export const RACE_NARROW_COLS = 6;

export interface SectorRaceWidgetProps extends WidgetProps {
  /** Opens `SYM/SPY` in the linked chart. */
  onOpenSymbol?: (symbol: string) => void;
}

export function SectorRaceWidget({ widget, onSettings, onRemove, onOpenSymbol }: SectorRaceWidgetProps) {
  const phone = useIsNarrow();
  const settings = useRaceSettings(widget, onSettings);
  const state = useRaceData(null, settings.freq);
  return (
    <WidgetCard
      title={WIDGET_META[widget.type].title}
      live={state.data?.live}
      onRemove={onRemove}
      subtitle={<RaceSubtitle />}
      controls={<RaceControls settings={settings} />}
    >
      <DataState state={state}>
        {(data) => (
          <RaceView
            data={data}
            settings={settings}
            narrow={phone || widget.w < RACE_NARROW_COLS}
            onOpenSymbol={onOpenSymbol}
          />
        )}
      </DataState>
    </WidgetCard>
  );
}
